import styled from 'styled-components';
import { Divider } from '@material-ui/core';

const CommonDivider = styled(Divider)`
  margin-top: 20px !important;
  margin-bottom: 20px !important;
`;

export default CommonDivider;
